<div class="title mb-4">
  <h4>GOOGLE BUSINESS SEARCH</h4>
</div>

<div class="row">
  <div class="col-lg-8 col-md-12">
    <h5 class="dash_subheading"></h5>
    <div class="white_box shadow p-3">
      <div class="purchase_div">
        <div class="job_plan mb-4 mt-4">
          <div class="row">
            <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
              <div class="card pt-3 text-center">
                <h3>Small Account</h3>

                <div
                  class="doller_icon mx-auto d-flex align-items-center justify-content-center"
                >
                  <img loading="lazy" src="../../../assets/images/gbb.png" alt="" />
                </div>
                <p class="snatcoin">20 VIP tokens</p>
                <!-- <p class="setprice">$ 99</p> -->

                <span class="save_info bg-transparent"> </span>

                <a
                  class="yellow_btn mx-auto my-3 yellow_btn_ded"
                  (click)="deduct_credits('20', 'Small Account')"
                  >Deduct Credits</a
                >
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
              <div class="card pt-3 text-center">
                <h3>Medium Account</h3>

                <div
                  class="doller_icon mx-auto d-flex align-items-center justify-content-center"
                >
                  <img loading="lazy" src="../../../assets/images/gbb.png" alt="" />
                </div>
                <p class="snatcoin">30 VIP tokens</p>
                <!-- <p class="setprice">$ 99</p> -->

                <span class="save_info bg-transparent"> </span>

                <a
                  class="yellow_btn mx-auto my-3 yellow_btn_ded"
                  (click)="deduct_credits('30', 'Medium Account')"
                  >Deduct Credits</a
                >
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
              <div class="card pt-3 text-center">
                <h3>Large Account</h3>

                <div
                  class="doller_icon mx-auto d-flex align-items-center justify-content-center"
                >
                  <img loading="lazy" src="../../../assets/images/gbb.png" alt="" />
                </div>
                <p class="snatcoin">40 VIP tokens</p>
                <!-- <p class="setprice">$ 99</p> -->

                <span class="save_info bg-transparent"> </span>

                <a
                  class="yellow_btn mx-auto my-3 yellow_btn_ded"
                  (click)="deduct_credits('40', 'Large Account')"
                  >Deduct Credits</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-4 col-md-12">
    <h5 class="dash_subheading">Available VIP tokens</h5>
    <div class="white_box">
      <div class="card_title">
        <p>Available VIP tokens</p>
      </div>
      <div class="icon_count">
        {{ total_txn }} <i class="fa-solid pl-2 fa-bars"></i>
      </div>
      <div class="right_side_text">
        <p (click)="view_all_transactions(view_all_transactions_popup)">
          View all transactions
        </p>
      </div>
    </div>

    <!-- <h5 class="dash_subheading my-4 ">Bonus VIP tokens</h5>

<div class="white_box ">
<div class="card_title">
    <p>Available VIP tokens</p>
</div>
<div class="icon_count">
    0 <i class="fa-regular fa-star"></i>
</div>
<div class="right_side_text">
    <p>View all transactions</p>
</div>
</div> -->

    <h5 class="dash_subheading mt-4">Description</h5>

    <div class="white_box">
      <div class="card_list">
        <ul class="">
          <li>
            <i class="fa-solid fa-circle-check pr-3 cg"></i>Searches are done
            for Google Maps daily for duration of 1 Month
          </li>
          <li>
            <i class="fa-solid fa-circle-check pr-3 cg"></i>Using specific
            keywords related to your businesses
          </li>
          <li>
            <i class="fa-solid fa-circle-check pr-3 cg"></i>10 - 20 a day to
            raise Map Ranking
          </li>
          <li>
            <i class="fa-solid fa-circle-check pr-3 cg"></i>Important to Pair
            with Map Pack Booster
          </li>
        </ul>
      </div>
    </div>

    <h5 class="dash_subheading my-4">Additional Info</h5>

    <div class="white_box">
      <div class="card_title mb-2">
        <p>Details</p>
      </div>
      <div class="card_list">
        <ul class="mb-5">
          <li>
            <i class="fa-solid fa-circle-check pr-3"></i>Top Up Credits for VIP
            token deductions
          </li>
          <li>
            <i class="fa-solid fa-circle-check pr-3"></i>Please check details
            before deductions
          </li>
          <li>
            <i class="fa-solid fa-circle-check pr-3"></i> Deductions are
            non-refundable
          </li>
          <li>
            <i class="fa-solid fa-circle-check pr-3"></i>MYVIP has the right to
            change any terms without prior communication
          </li>
        </ul>

        <!-- <a href="#" class="yellow_btn text-center d-block findout">
          Find out more
        </a> -->
      </div>
    </div>
  </div>
</div>

<!-- <ng-template #view_all_transactions_popup let-modal>
  <button type="button" class="close close_modal" style="outline: none;" (click)="modal.dismiss('Cross click')"
      data-dismiss="modal"><span aria-hidden="true">×</span></button>

  <div class="modal-header">
      <h5 class="modal_title">VIP Tokens Deduction Report</h5>
  </div>
  <div class="modal-body p-4">
      <div class="row">
          <div class="col-md-12">
              <table class="table">
                  <thead class="thead-light">
                      <tr>
                          <th scope="col">Sr.No.</th>
                          <th scope="col">Detail</th>
                          <th scope="col">VIP Tokens</th>
                          <th scope="col">Ded. Status</th>
                          <th scope="col">Date</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let i of transactions; let a = index">
                          <th scope="row">{{ a + 1 }}</th>
                          <td>Deduct VIP Token</td>
                          <td>{{ i.tokens }}</td>
                          <td>completed</td>
                          <td>{{ i.created * 1000 | date:'medium' }}</td>
                      </tr>
                  </tbody>
              </table>
          </div>
      </div>
  </div>
</ng-template> -->

<ng-template #view_all_transactions_popup let-modal>
  <button
    type="button"
    class="close close_modal"
    style="outline: none"
    (click)="modal.dismiss('Cross click')"
    data-dismiss="modal"
  >
    <span aria-hidden="true">×</span>
  </button>

  <div class="modal-header">
    <h5 class="modal_title">VIP Tokens Report</h5>
  </div>
  <div class="modal-body p-4">
    <div class="row">
      <div class="col-md-12 add_ded_tbl">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th scope="col">Sr.No.</th>
              <th scope="col">Detail</th>
              <th scope="col">VIP Tokens</th>
              <th scope="col">Txn. Status</th>
              <th scope="col">Ded. From</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i of transactions; let a = index">
              <th scope="row">{{ a + 1 }}</th>
              <td>
                <span *ngIf="i.add_deduct == 'add'">Add VIP Token</span>
                <span *ngIf="i.add_deduct == 'deduct'">Deduct VIP Token</span>
              </td>
              <td>{{ i.tokens }}</td>
              <td>
                <span *ngIf="i.add_deduct == 'add'">{{ i.status }}</span>
                <span *ngIf="i.add_deduct == 'deduct'">complete</span>
              </td>
              <td>
                <span *ngIf="i.type == 0"><i class="fas fa-coins"></i></span>
                <span *ngIf="i.type == 1"><i class="fab fa-google"></i></span>
                <span *ngIf="i.type == 2"
                  ><i class="fab fa-instagram"></i
                ></span>
                <span *ngIf="i.type == 3"><i class="fab fa-twitter"></i></span>
                <span *ngIf="i.type == 4"> GM {{ i.show }} </span>
                <span *ngIf="i.type == 5"> ST {{ i.show }} </span>
                <span *ngIf="i.type == 6"> {{ i.show }} </span>
              </td>
              <td>{{ i.created * 1000 | date : "medium" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>
